// 数据校验初始化
function validatorInit() {
  if ($.validator) {
    $.validator.setDefaults({
      errorElement: 'div',
      // eslint-disable-next-line no-unused-vars
      highlight(element, errorClass, validClass) {
        $(element).addClass('is-invalid')
      },
      // eslint-disable-next-line no-unused-vars
      unhighlight(element, errorClass, validClass) {
        $(element).removeClass('is-invalid')
        if ($(element).hasClass('select2')) {
          $(element).siblings('.select2-container').find('.select2-selection').removeClass('is-invalid')
        }
      },
      errorPlacement(error, element) {
        element.closest('div').append(error)
        if (element.hasClass('select2')) {
          element.siblings('.select2-container').find('.select2-selection').addClass('is-invalid')
        }
      }
    })
    /*    $.validator.defaults.errorPlacement = function (error, element) {
      console.log(555)
      error.addClass('invalid-feedback');
      element.closest('.form-group').append(error);
    } */
    // 原规则重写
    // email 重写
    $.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(value);
    }

    $.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(value);
    }

    // 自定义
    // 手机号
    $.validator.addMethod("phone", function (value, element) {
      return this.optional(element) || /^1[3|4|5|6|7|8|9]\d{9}$/.test(value);
    }, "请输入有效的手机号码");
  }
}

export default validatorInit
